export default __webpack_public_path__ + "static/media/arrow-left.110063be.svg";